/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Room_Temperatures_To_Pre_Comfort_AbsenceInputs */

/** @type {(inputs: Room_Temperatures_To_Pre_Comfort_AbsenceInputs) => LocalizedString} */
const fr_room_temperatures_to_pre_comfort_absence = () => /** @type {LocalizedString} */ ('room_temperatures_to_pre_comfort_absence')

/**
* | output |
* | --- |
* | "Pre-comfort and absence temperature" |
*
* @param {Room_Temperatures_To_Pre_Comfort_AbsenceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const room_temperatures_to_pre_comfort_absence = /** @type {((inputs?: Room_Temperatures_To_Pre_Comfort_AbsenceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Temperatures_To_Pre_Comfort_AbsenceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pre-comfort and absence temperature")
	return fr_room_temperatures_to_pre_comfort_absence(inputs)
});